import {
    GetStaticPaths,
    GetStaticPropsContext,
    GetStaticPropsResult,
    NextPage
} from 'next/types'
import { useEffect, useState } from 'react'
import { PostProps } from '../../../../../libs/model/post-wp'
import { Body } from '../../../../../libs/components/header/Header.styled'
import HeaderComponent from '../../../../../libs/components/header'
import { useRouter } from 'next/navigation'
import {
    AvatarDS,
    ButtonDS,
    FooterComponent
} from '../../../../../libs/components'
import {
    Attachment,
    AuthorAlert,
    BodyCenter,
    ButtonContainer,
    HTMLContent,
    PostContainer
} from '../../../../../libs/style/post-page'
import { useRouter as nextRouter } from 'next/router'
import {
    addDatalayer,
    cleanMCTable,
    formatFriendlyDate,
    getToken
} from '@App/libs/utils/geral'
import { UNDEFINED } from '@App/libs/utils/constants/global'
import { StoreType } from '@App/api/types/store'
import { useSelector } from 'react-redux'
import {
    fetchAlertaBySlug,
    getLastPRONews,
    getPostPROFromOpenSearch,
    jotaPROApi
} from '@App/api/api'
import { PROContent, ProLastNews } from '@App/libs/model/pro-nl'
import { LoadingContent } from '@App/libs/components/loading/Loading.component'
import LastNews from '@App/libs/components/LastNews'
import { Auth } from 'aws-amplify'
import {
    NOTICIA_ROUTE,
    PRO_ROUTE,
    JU_LOGINREDIRECT,
    INSIDE_JU
} from '@App/libs/utils/constants/auth'
import {
    ALERTAS,
    ItemsBulletLP,
    NEWSLETTER,
    PRO
} from '@App/libs/utils/constants/pro'
import { URLS } from '@App/libs/utils/constants/route'
import { LAYOUT_CONSTANT, ROUTE_CONSTANT } from '@App/libs/utils/constants'
import Metadata from '@App/libs/components/Metadata.component'
import { PageTypeEnum } from '@App/libs/interfaces'
import dynamic from 'next/dynamic'
import { Timestamp } from '@App/libs/components/Timestamp'
import { ProContentHeader } from '@App/libs/components/ProContentHeader'
import Link from 'next/link'
import BreadcrumbComponentJU, {
    makeBreadItemsFromOS
} from '@App/libs/components/ds/Breadcrumb'
import { VerticalName, VerticalType } from '@App/libs/interfaces/PRO.interfaces'

const ModalDS = dynamic(
    () => import('@App/libs/components/modal').then((mod) => mod.ModalDS),
    { ssr: false }
)

export const { SM } = LAYOUT_CONSTANT.BREAKPOINTS

export type metadataType = {
    title: string
    description: string
    url: string
    keywords: string
}

const BTN_DEFAULT_LABEL = 'LEIA O RELATÓRIO COMPLETO'

const ALERTS_MAP: Record<string, VerticalName> = {
    poder: VerticalName.PODER,
    saude: VerticalName.SAUDE
}

/**
 * Resolve vertical
 * @param {string} contentType
 * @param {string} verticalQuery
 * @param {VerticalType} defaultVertical
 * @return {VerticalType}
 */
export function resolveVertical(
    contentType: string,
    verticalQuery: string,
    defaultVertical: VerticalType
): VerticalType {
    if (contentType === 'ALERTAS') {
        const resolvedVertical = ALERTS_MAP[verticalQuery.toLowerCase()]
        if (resolvedVertical) {
            return resolvedVertical
        }
    }

    return defaultVertical
}

const PostPage: NextPage<PostProps> = ({ header, footer, title }) => {
    const [contentPRO, setContentPRO] = useState<PROContent | null>(null)
    const [datePost, setDatePost] = useState<{ date: string; time: string }>()
    const { user } = useSelector((state: StoreType) => state.auth)
    const userBO: any = user?.getUserBO()
    const [lastNews, setLastNews] = useState<ProLastNews[] | null>(null)
    const router = useRouter()
    const { asPath, query } = nextRouter()
    const { slug } = query
    const [modal, setModal] = useState<{
        show: boolean
        vertical: VerticalType
    }>({
        show: false,
        vertical: VerticalName.PODER
    })

    const contentType = query.category === ALERTAS ? ALERTAS : NEWSLETTER

    useEffect(() => {
        const getAPIProContent = async () => {
            const token = (await getToken()) as string

            if (!token || !slug) return false

            if (contentType === NEWSLETTER) {
                jotaPROApi(slug as string, token)
                    .then((response: any) => {
                        const data = response.data

                        if (data) {
                            if (data.errata?.id) {
                                window.location.href = data.errata?.slug
                            }

                            if (
                                data.send_time &&
                                typeof data.send_time === 'string'
                            ) {
                                const datePostTemp = new Date(
                                    data.send_time.toLocaleString('pt-BR', {
                                        timeZone: 'America/Sao_Paulo'
                                    })
                                )

                                datePostTemp.setHours(datePostTemp.getHours())

                                setDatePost(
                                    formatFriendlyDate(
                                        datePostTemp.toISOString()
                                    )
                                )
                            }
                        }
                        setContentPRO(data)

                        const userBO = user?.getUserBO() as any

                        const dataTemp = {
                            url: window.location.href,
                            title: data.title,
                            vertical: data.category.vertical.name,
                            history_page: document.referrer,
                            date: new Date(),
                            user_company: userBO?.profile?.company_name,
                            user_tier: userBO?.profile?.company_tier,
                            user_company_other:
                                userBO?.profile?.company_type_other,
                            user_plan: userBO?.profile?.plan,
                            user_vertical: userBO?.verticals,
                            type: 'JU'
                        }

                        addDatalayer({
                            event: 'clique_conteúdo_pro_unico',
                            ...dataTemp
                        })
                    })
                    .catch((error) => {
                        setModal({
                            show: true,
                            vertical: error.response.data.category.vertical.name
                        })
                    })
            } else if (
                query.vertical === VerticalName.PODER.toLowerCase() &&
                !userBO?.profile?.has_poder
            ) {
                setModal({
                    show: true,
                    vertical: PRO.PODER as VerticalType
                })
            } else if (
                query.vertical === VerticalName.SAUDE.toLowerCase() &&
                !userBO?.profile?.has_saude
            ) {
                setModal({
                    show: true,
                    vertical: PRO.SAUDE as VerticalType
                })
            } else {
                fetchAlertaBySlug(slug as string, token)
                    .then((data) => {
                        setContentPRO(data)
                        setDatePost(formatFriendlyDate(data.publishedAt))
                    })
                    .catch(() => {
                        setModal({
                            show: true,
                            vertical: PRO.PODER as VerticalType
                        })
                    })
            }

            getLastPRONews().then((res: any) => setLastNews(res.data.hits.hits))
        }

        Auth.currentAuthenticatedUser()
            .then(() => {
                if (typeof localStorage != UNDEFINED && user?.getEmail()) {
                    getAPIProContent()
                }
            })
            .catch(() => {
                if (
                    asPath.includes(NOTICIA_ROUTE) ||
                    asPath.includes(PRO_ROUTE)
                ) {
                    localStorage.setItem(JU_LOGINREDIRECT, asPath)
                }
                localStorage.setItem(INSIDE_JU, 'true')

                router.push(
                    `${ROUTE_CONSTANT.ROUTE.LOGIN}?vertical=${
                        asPath.split('/')[1]
                    }`
                )
            })
    }, [
        user,
        asPath,
        router,
        slug,
        contentType,
        query.vertical,
        userBO?.profile?.has_poder,
        userBO?.profile?.has_saude
    ])

    const clickModalClose = () => {
        router.push(URLS.home)
    }

    const getContent = () => {
        if (!contentPRO) return ''
        if (contentType === NEWSLETTER && 'html_content' in contentPRO) {
            return cleanMCTable(contentPRO.html_content) as string
        } else if ('content' in contentPRO) {
            return contentPRO.content
        }
        return ''
    }

    const hasAttachment = () => {
        if (
            contentType !== ALERTAS ||
            !contentPRO ||
            !('assets' in contentPRO) ||
            contentPRO.assets?.length === 0
        ) {
            return false
        }

        if (contentPRO.assets) {
            for (const asset of contentPRO.assets) {
                if (
                    (asset.leading && asset.short_url) ||
                    (!asset.leading && contentPRO.assets.length === 1)
                ) {
                    const dataTemp = {
                        label: BTN_DEFAULT_LABEL,
                        url: asset.short_url
                    }

                    return (
                        <ButtonContainer>
                            <Link href={asset.short_url} target='_blank'>
                                <ButtonDS
                                    size={'large'}
                                    {...dataTemp}
                                    color='black'
                                    type='filled'
                                />
                            </Link>
                        </ButtonContainer>
                    )
                }
            }
        }
    }

    return (
        <div className='page' data-page-type='pro-content'>
            <ModalDS
                isOpen={modal.show}
                bulletItems={ItemsBulletLP}
                vertical={resolveVertical(
                    contentType,
                    query.vertical as string,
                    modal.vertical
                )}
                closeModal={clickModalClose}
            />

            <Body>
                {header && (
                    <HeaderComponent
                        wpMenu={header.menu}
                        ctaPRO={header.pro}
                        showAcessibility={header.enableAccessibility}
                        signupLink={header.assinePage}
                        bannerTop={header.top_banner}
                    />
                )}

                <BodyCenter>
                    {contentPRO ? (
                        <PostContainer>
                            <Metadata
                                title={`JOTA PRO - ${title || ''}`}
                                description={`${'category' in contentPRO ? contentPRO.category.name : ''} - ${'category' in contentPRO ? contentPRO.category.vertical.name : ''}`}
                                authors={[
                                    {
                                        name: 'Equipe JOTA PRO',
                                        bio: 'Equipe especializada na cobertura dos Três Poderes'
                                    }
                                ]}
                                breadcrumb={makeBreadItemsFromOS(asPath)}
                                pageType={PageTypeEnum.POSTPRO}
                                dates={{
                                    publication_iso8601: datePost
                                        ? new Date(
                                              `${datePost.date.split('/').reverse().join('-')}T${datePost.time}`
                                          )
                                              .toISOString()
                                              .replace('Z', '-03:00')
                                        : ''
                                }}
                            />

                            {makeBreadItemsFromOS(asPath) && (
                                <BreadcrumbComponentJU
                                    items={makeBreadItemsFromOS(asPath)}
                                />
                            )}

                            {contentPRO && (
                                <ProContentHeader contentPro={contentPRO} />
                            )}

                            {datePost && <Timestamp datePost={datePost} />}

                            <HTMLContent
                                dangerouslySetInnerHTML={{
                                    __html: getContent()
                                }}
                            />

                            {contentType === ALERTAS && (
                                <>
                                    <Attachment>{hasAttachment()}</Attachment>

                                    <AuthorAlert>
                                        <AvatarDS
                                            size={'60'}
                                            imagePath={
                                                '/images/icons/alert-autors.svg'
                                            }
                                            alt={'Equipe JOTA PRO'}
                                        />
                                        <h2>Equipe JOTA PRO</h2>
                                    </AuthorAlert>
                                </>
                            )}
                        </PostContainer>
                    ) : (
                        <LoadingContent />
                    )}
                    {lastNews && <LastNews news={lastNews} />}
                </BodyCenter>
                {footer && <FooterComponent footer={footer} />}
            </Body>
        </div>
    )
}

export default PostPage

export const getStaticPaths: GetStaticPaths<{ slug: string }> = async () => {
    return {
        paths: [],
        fallback: 'blocking'
    }
}

/**
 * Pega o titulo da materia do OpenSearch para que apareça o title correto no GA4.
 * Não pego da API PRO porque seria necessário o Token.
 * @param {string} slug - O identificador do conteúdo.
 * @param {string} categorySlug - A categoria do conteúdo.
 * @param {string} verticalSlug - O vertical do conteúdo.
 * @return {Promise<GetStaticPropsResult<HomePagePropsInterface>>}
 */
const getTitleFromOpenSearch = async (
    slug: string,
    categorySlug: string,
    verticalSlug: string
): Promise<string> => {
    const rawData = await getPostPROFromOpenSearch(
        slug,
        categorySlug,
        verticalSlug
    )

    const data = rawData as {
        hits?: {
            hits: {
                _source: {
                    title?: {
                        headline?: string
                    }
                }
            }[]
        }
    }

    const headline = data?.hits?.hits?.[0]?._source?.title?.headline
    return headline || 'Conteúdo PRO'
}

/**
 * getStaticProps
 * @param {unknow} context
 * @return {Promise<GetStaticPropsResult<HomePagePropsInterface>>}
 */
export const getStaticProps = async (
    context: GetStaticPropsContext<{
        slug: string
        category: string
        vertical: string
    }>
): Promise<GetStaticPropsResult<any>> => {
    if (process?.env?.NEXT_PUBLIC_HEADER_AND_FOOTER) {
        const apiData = await (
            await fetch(process?.env?.NEXT_PUBLIC_HEADER_AND_FOOTER)
        ).json()
        const { header, footer } = apiData

        // Pega o titulo da materia para ter isso em tempo de servidor para que apareça o title
        // correto no GA4.
        const { slug, category, vertical } = context.params || {}

        const title = await getTitleFromOpenSearch(
            slug as string,
            category as string,
            vertical as string
        )

        return {
            props: {
                header,
                footer,
                title
            }
        }
    } else {
        return {
            props: {}
        }
    }
}
